import { render } from "./EditKanban.vue?vue&type=template&id=452b7841"
import script from "./EditKanban.vue?vue&type=script&lang=js"
export * from "./EditKanban.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__